
import { ModelBase } from "@models/UpsertableBase";
import { RollOption } from "@dndModels/misc";
import { DataType } from "@dndModels/Types";

export class RollableTable extends ModelBase {
  data_type: DataType = "rollable_table";
  dice_size = 20;
  roll_options: RollOption[] = [];

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.dice_size = obj.dice_size ? obj.dice_size : 20;
      this.roll_options = obj.roll_options ? obj.roll_options : [];
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.dice_size = obj.dice_size ? obj.dice_size : 20;
  //     this.roll_options = obj.roll_options ? obj.roll_options : [];
  //   }
  // }

  toDBObj(): any {
    const super_obj = super.toDBObj();
    return {
      ...super_obj,
      dice_size: this.dice_size,
      roll_options: this.roll_options
    };
  }

  copy(copyMe: RollableTable, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.dice_size = copyMe.dice_size;
    this.roll_options = [...copyMe.roll_options];
  }

  clone(drop_ids = false): RollableTable {
    const new_obj = new RollableTable();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}